import {
  sanatizeObjectData,
  lightenDarkenColor
} from './utils/utils'
import {
  getElementById,
  createInlineStyle
} from './utils/dom'
import { BOT_IMAGE_URL } from './config/config'

const drrorymcgoldrickBotId = '2331f1e9-a903-4cc7-87a3-795ee5f58257'

const clientBasedFontFamily = (botId) => {
  if (botId === drrorymcgoldrickBotId) {
    return 'gotham, sans-serif'
  }
  return 'proxima-nova, sans-serif'
}

export const theme = {
  speed: 4,
  style: 'Container Less',
  auto_show: true,
  icon_type: 2,
  placement: 2,
  is_cta_btn: true,
  is_rounded: true,
  powered_by: 'By EnquiryBot',
  eb_branding: true,
  icon_colour: '#000000',
  is_uploaded: false,
  start_delay: 7,
  website_url: 'https://www.enquirybot.com',
  off_set_type: 1,
  pop_in_phone: true,
  side_spacing: 25,
  trigger_text: 'Make an Enquiry',
  is_single_btn: false,
  offset_pixels: 0,
  overlay_close: '#ffffff',
  overlay_color: '#fecc02',
  primary_color: '#cf7156',
  bottom_spacing: 25,
  pop_in_desktop: true,
  start_on_hover: false,
  custom_branding: false,
  input_bg_colour: '#ffffff',
  is_cta_bg_solid: false,
  is_cta_text_btn: false,
  preview_bg_type: 3,
  secondary_color: '#b8b8b7',
  selected_avatar: 'https://eb-app-image-upload.s3-eu-west-1.amazonaws.com/2023-04-0315_34_39_770605.blob',
  button_bg_colour: '#dc6e53',
  is_widget_offset: false,
  preview_bg_image: 'https://eb-app-image-upload.s3-eu-west-1.amazonaws.com/2023-05-2414_02_12_393684_Screenshot2023-05-24at15_01_59.png',
  bot_msg_bg_colour: '#ffffff',
  input_text_colour: '#1f1e1e',
  option_text_color: '#1f1e1e',
  preview_bg_colour: '#f5f5f5',
  button_text_colour: '#ffffff',
  is_cta_bg_gradient: true,
  show_bot_on_mobile: true,
  bot_msg_text_colour: '#1f1e1e',
  popover_text_colour: '#ffffff',
  preview_website_url: 'www.humblegrape.co.uk',
  reply_msg_bg_colour: '#ffffff',
  show_bot_on_desktop: true,
  contained_background: '#e6e6e6',
  cta_bg_gradient_left: '#cf7156',
  cta_bg_gradient_right: '#f09070',
  is_chat_icon_bg_solid: true,
  reply_msg_text_colour: '#1f1e1e',
  cta_btn_bg_solid_color: '#602541',
  colour_advance_settings: true,
  option_background_color: '#ffffff',
  full_screen_transparency: 0,
  is_chat_icon_bg_gradient: false,
  mobile_background_colour: '#000000',
  bottom_spacing_for_mobile: 25,
  chat_icon_bg_solid_colour: '#ffffff',
  chat_icon_bg_gradient_left: '#3856de',
  side_screen_gradient_angle: 270,
  chat_icon_bg_gradient_right: '#fecc02',
  mobile_full_screen_transparency: 60,
  desktop_side_screen_transparency: 60,
  option_container_background_color: '#ffffff',
  automatically_open_the_bot_on_mobile: false,
  automatically_open_the_bot_on_desktop: false,
  desktop_side_screen_gradient_end_colour: '#fecc02',
  desktop_side_screen_gradient_start_colour: '#ffffff',
  automatically_open_the_bot_on_mobile_delay: 5,
  automatically_open_the_bot_on_desktop_delay: 5
}

export const setUpHeader = (botId) => {
  const themeData = theme

  document.documentElement.style.setProperty('--primary-color', sanatizeObjectData(themeData.primary_color, '#3856de'))
  document.documentElement.style.setProperty('--primary-color-lite', lightenDarkenColor(sanatizeObjectData(themeData.primary_color, '#3856de'), 70))
  if (themeData.is_cta_bg_gradient) {
    document.documentElement.style.setProperty(
      '--pop-over-bg',
      sanatizeObjectData(themeData.cta_bg_gradient_left)
    )
    document.documentElement.style.setProperty(
      '--pop-over-bg-lite',
      lightenDarkenColor(
        sanatizeObjectData(themeData.cta_bg_gradient_right),
        70
      )
    )
  } else {
    document.documentElement.style.setProperty(
      '--pop-over-bg',
      sanatizeObjectData(themeData.cta_btn_bg_solid_color)
    )
    document.documentElement.style.setProperty(
      '--pop-over-bg-lite',
      lightenDarkenColor(
        sanatizeObjectData(themeData.cta_btn_bg_solid_color),
        70
      )
    )
  }
  document.documentElement.style.setProperty('--pop-over-text', sanatizeObjectData(themeData.popover_text_colour, '#ffffff'))
  document.documentElement.style.setProperty('--overlay-color', sanatizeObjectData(themeData.overlay_color, '#fecc02'))
  document.documentElement.style.setProperty('--overlay-close', sanatizeObjectData(themeData.overlay_close, '#ffffff'))
  document.documentElement.style.setProperty('--contained-background', sanatizeObjectData(themeData.contained_background, '#e6e6e6'))
  document.documentElement.style.setProperty('--contained-font-family', clientBasedFontFamily(botId))
  if (themeData.secondary_color) {
    document.documentElement.style.setProperty('--secondary-lite', lightenDarkenColor(themeData.secondary_color, 50))
  }
  const avatarStyle = createInlineStyle('bot-avatar',
    `.bot-avatar {
    background-image: url(${BOT_IMAGE_URL}) !important;
    }`
  )
  const botAvatar = getElementById('bot-avatar')
  if (!botAvatar) {
    document.head.append(avatarStyle)
  }

  if (themeData && themeData.selected_avatar) {
    avatarStyle.innerHTML = `.bot-avatar {
        background-image: url(${themeData.selected_avatar}) !important;
      }`
  }
  if (botAvatar) {
    botAvatar.innerHTML = avatarStyle.innerHTML
  }
}
